import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../hooks/useTheme';

// Components
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import FeaturedProducts from '../components/landing/FeaturedProducts';
import Categories from '../components/landing/Categories';
import Footer from '../components/landing/Footer';
import GcrRatingBadge from '../components/landing/GcrRatingBadge';

const LandingPage = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`landing-page theme-${theme}`}>
            <Helmet>
                <title>Laptops.pe – Laptops de todas las marcas en Perú</title>
                <meta name="description" content="Compra laptops de todas las marcas con accesorios y repuestos originales. Envío a todo el Perú con tiempos estimados según zona, garantía y soporte experto. Compra 100% segura." />
                <meta name="keywords" content="laptops, computadoras, gaming, tecnología, Perú, Laptops.pe" />
                <meta property="og:title" content="Laptops.pe – Laptops de todas las marcas en Perú" />
                <meta property="og:description" content="Compra laptops de todas las marcas con accesorios y repuestos originales. Envío a todo el Perú con tiempos estimados según zona, garantía y soporte experto. Compra 100% segura." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={process.env.REACT_APP_SITE_URL} />
                <meta property="og:image" content={`${process.env.REACT_APP_SITE_URL}/og-image.jpg`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Laptops.pe – Laptops de todas las marcas en Perú" />
                <meta name="twitter:description" content="Compra laptops de todas las marcas con accesorios y repuestos originales. Envío a todo el Perú con tiempos estimados según zona, garantía y soporte experto. Compra 100% segura." />
                <meta name="twitter:image" content={`${process.env.REACT_APP_SITE_URL}/og-image.jpg`} />
                <link rel="canonical" href={process.env.REACT_APP_SITE_URL} />
                {/* Datos estructurados de la organización para transparencia de identidad */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Organization',
                        name: 'DIGITAL WINS E.I.R.L.',
                        legalName: 'DIGITAL WINS E.I.R.L.',
                        alternateName: 'Laptops.pe',
                        url: process.env.REACT_APP_SITE_URL,
                        logo: `${process.env.REACT_APP_SITE_URL}/logotipo-hor-light.png`,
                        taxID: '20612859630',
                        brand: {
                            '@type': 'Brand',
                            name: 'Laptops.pe'
                        },
                        sameAs: [
                            'https://www.facebook.com/laptops.pe',
                            'https://www.instagram.com/laptops.pe',
                            'https://www.tiktok.com/@laptops_pe'
                        ],
                        contactPoint: [{
                            '@type': 'ContactPoint',
                            telephone: '+51 978 326 796',
                            contactType: 'customer service',
                            areaServed: 'PE',
                            availableLanguage: ['es']
                        }],
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: 'PSJ. EL TRIUNFO MZA. S LOTE. 37A INT. 502 URB. SAN LUIS',
                            addressLocality: 'San Luis',
                            addressRegion: 'Lima',
                            postalCode: '15021',
                            addressCountry: 'PE'
                        }
                    })}
                </script>
            </Helmet>

            <Header theme={theme} onToggleTheme={toggleTheme} />
            
            <main className="landing-main">
                <HeroSection />
                <FeaturedProducts />
                <div className="surface-section px-4 py-6 md:px-6 lg:px-8">
                    <h2 className="text-2xl font-semibold mb-3">Opiniones verificadas por Google</h2>
                    <p className="text-700 mb-3">Transparencia y confianza: mostramos nuestro puntaje del programa Google Customer Reviews.</p>
                    <GcrRatingBadge />
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default LandingPage;
